import { render } from "./DomesticCorporate.vue?vue&type=template&id=227b9223&scoped=true&ts=true"
import script from "./DomesticCorporate.vue?vue&type=script&lang=ts"
export * from "./DomesticCorporate.vue?vue&type=script&lang=ts"

import "./DomesticCorporate.vue?vue&type=style&index=0&id=227b9223&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227b9223"]])

export default __exports__